const STAGE_COLORS = ["#4d82d9", "#7d64c7", "#2db89a", "#d4a017", "#df695b", "#4aa7a1", "#bd7fce", "#729dcf", "#bd8a58", "#d6708c", "#80a65b", "#9b78dc", "#e6bd69", "#68c9e0"];

// Preserve existing stage colors and always supply a visible color for new stages.
export function stageColor(index: number): string {
  return STAGE_COLORS[index] ?? `hsl(${Math.round(index * 137.508) % 360} 65% 64%)`;
}
